import theme from '../theme';

export default () => ({
  theme,
  color: (name) => theme.mode[name].color,
  background: (name) => theme.mode[name].background,
  fontWeight: (mode, weight) => theme.typography[mode][weight],
  fontFamily: (mode) => theme.typography[mode].family,
});
